<template>
    <footer class="bg-zinc-900">
        <div class="container mx-auto py-3 lg:py-5">
            <div class="grid gap-5 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6">
                <div v-for="(item, itemIdx) in nav" :key="itemIdx">
                    <div class="text-white mb-3">
                        {{ item.title }}
                    </div>
                    <div class="text-sm text-zinc-500">
                        <div v-if="itemIdx === 0" class="mb-4">
                            <contact :customer-config="customerConfig" />
                            <div class="text-left border-t border-t-zinc-700 mt-2 pt-2">
                                <p class="text-xs text-zinc-700">
                                    {{ __("Wersja") }} {{ appVersion }} @QA2
                                </p>
                            </div>
                        </div>
                        <div
                            v-for="(subItem, subItemIdx) in item.children"
                            :key="subItemIdx"
                        >
                            <router-link
                                :to="{
                                    name: 'category',
                                    params: {
                                        lang: $store.getters.lang,
                                        id: subItem.id,
                                        slug: subItem.slug,
                                    },
                                }"
                                class="hover:text-zinc-400"
                            >
                                {{ subItem.title }}
                            </router-link>
                        </div>
                    </div>
                </div>

                <div class="md:col-span-3 lg:col-start-4 xl:col-start-6 text-right">
                    <div class="hidden text-white mb-3 lg:block">Social Media</div>
                    <socialmedia :customer-config="customerConfig" />
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import Contact from "./Footer/Contact.vue";
import Socialmedia from "./Footer/Socialmedia.vue";

export default {
    name: "PageFooter",
    components: {
        Contact,
        Socialmedia,
    },
    data() {
        return {
            nav: [],
        };
    },

    computed: {
        appVersion() {
            return process.env.VUE_APP_VERSION;
        },

        customerConfig() {
            return this.$store.getters.customerConfig;
        },
    },

    created() {
        if (this.$store.getters.scope) {
            this.fetchData();
        }

        this.$emitter.on("scopeUpdated", () => {
            this.fetchData();
        });

        this.$emitter.on("localeUpdated", () => {
            this.fetchData();
        });
    },

    methods: {
        fetchData() {
            this.$api.get("/navigation/bottom").then((data) => (this.nav = data.nav));
        },
    },
};
</script>
